module.exports = __webpack_public_path__ + "img/resources.8912cbe0.png";